import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { IPDCReportTemplate } from "../../../../components";
import { GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";
import useDecodedUser from "../../../../services/hooks/useDecodedUser";

const DisplayAppropriateReport = ({ reportType, department = "finance", title = null }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const decodedUser = useDecodedUser();

  // Helper function to safely convert any object values to strings
  const safeStringifyObjects = (obj) => {
    if (!obj || typeof obj !== 'object') return obj;
    
    const newObj = { ...obj };
    Object.keys(newObj).forEach(key => {
      const value = newObj[key];
      // Check if value is an object and not null and not an array
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        newObj[key] = JSON.stringify(value);
      }
      // Handle arrays that might contain objects
      else if (Array.isArray(value)) {
        newObj[key] = value.map(item => 
          item && typeof item === 'object' ? JSON.stringify(item) : item
        );
      }
    });
    return newObj;
  };

  useEffect(() => {
    const fetchReport = async () => {
      setLoading(true);
      try {
        let result
        if(reportType=='landUseProportion'){
           result = await GetDataFromApiWithParams(`availableParcel/${decodedUser?.park_id}`);
        }
        else{

           result = await GetDataFromApiWithParams(
            `reports/${department}/reportType/${reportType}`, 
            { parkid: decodedUser?.park_id }
          );
          
        }
        if (result && Array.isArray(result)) {
          // Transform each item in the result array
          const transformedData = result.map(item => safeStringifyObjects(item));
          setData(transformedData);
          console.log("Transformed data:", transformedData);
        } else if (result && typeof result === 'object') {
          // If result is a single object (not array), wrap it in array
          const transformedData = [safeStringifyObjects(result)];
          setData(transformedData);
        } else {
          setData([]);
        }
      } catch (err) {
        console.log("Error fetching report:", err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    if (decodedUser?.park_id) {
      fetchReport();
    } else {
      setLoading(false);
    }
  }, [department, reportType, decodedUser?.park_id]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <CircularProgress />
      </div>
    );
  }

  return data && data.length > 0 ? (
    <IPDCReportTemplate 
      defaultTitle={title ? title : `${department} Report`} 
      data={data} 
      setData={setData} 
    />
  ) : (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      No data available yet!
    </div>
  );
};

export default DisplayAppropriateReport;